import React, { useState, useEffect } from "react";
import { SearchOutlined, FilterOutlined } from "@ant-design/icons";
import { Button, Space, DatePicker } from "antd";
import moment from "moment/moment";

const { RangePicker } = DatePicker;

const DateFilter = (item, search) => {
  const Filter = ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
    const [times, setTimes] = useState([]);
    useEffect(() => {
      console.log(selectedKeys)
      setTimes(selectedKeys);
    }, [selectedKeys]);

    const handleSearch = () => {
      const [startTime, endTime] = times || [];
      let timeAry = []
      if (startTime && endTime) {
        timeAry = [moment(startTime).format('x'), moment(endTime).format('x')]
      }

      setSelectedKeys(times);
      search({
        column_text: item.title,
        column_name: item.dataIndex,
        values: timeAry,
        column_type: 3,
        type: 'date'
      })
      confirm();
    };
    const handleReset = (clearFilters) => {
      clearFilters();
    };
    return (
      <div
        style={{
          padding: 8,
        }}
      // onKeyDown={(e) => e.stopPropagation()}
      >
        <div style={{ marginBottom: 8, width: "202px" }}>
          <RangePicker
            value={times}
            onChange={(value) => {
              setTimes(value);
            }}
          />
        </div>
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch()}
            icon={<SearchOutlined />}
            style={{
              width: 90,
            }}
          >
            搜索
          </Button>
          <span style={{ visibility: "hidden" }}>-</span>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            style={{
              width: 90,
            }}
          >
            清空
          </Button>
        </Space>
      </div>
    );
  };

  return {
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys = [],
      confirm,
      clearFilters,
    }) => (
      <Filter
        setSelectedKeys={setSelectedKeys}
        selectedKeys={selectedKeys}
        confirm={confirm}
        clearFilters={clearFilters}
      />
    ),
    filterIcon: (filtered) => (
      <FilterOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
  };
};
export default DateFilter;
